import { useMemo } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import { SelectField } from '../SelectField';
import data3dprint from '../../../../config/data3dprint.json';

interface PrinterFieldProps {
  value: number | undefined;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isActive?: boolean;
  isNext?: boolean;
  disabled?: boolean;
  selectedTechnology: string;
}

export function PrinterField({
  value,
  onChange,
  onFocus,
  onBlur,
  isActive = false,
  isNext = false,
  disabled = false,
  selectedTechnology
}: PrinterFieldProps) {
  const theme = useTheme(state => state.getThemeStyles());

  const options = useMemo(() => {
    const technology = data3dprint.technologies.find(
      tech => tech.name === selectedTechnology
    );

    if (!technology) return [];

    return technology.printers.map(printer => ({
      id: printer.id,
      name: printer.name,
      description: printer.description
    }));
  }, [selectedTechnology]);

  return (
    <div className={theme.components.input.variants.select.group}>
      <label 
        htmlFor="printer"
        className={`
          ${theme.components.input.variants.select.label.base}
          ${disabled ? theme.components.input.variants.select.label.disabled : ''}
        `}
      >
        Impressora
      </label>
      <SelectField
        name="printer"
        label="Impressora"
        options={options}
        value={value}
        onChange={onChange}
        isActive={isActive}
        isNext={isNext}
        disabled={disabled || !selectedTechnology}
      />
      {value && (
        <span className={theme.components.input.variants.select.description}>
          {options.find(opt => opt.id === value)?.description}
        </span>
      )}
    </div>
  );
} 